// Components
import Image from "@/components/image";

export default function Hero({
  blok,
  entry,
}: {
  blok: { content: string; title: string };
  entry: any;
}) {
  return (
    <div className="relative">
      <Image height={640} image={blok.image} priority={true} width={1920} />
      <span className="absolute pointer-events-none left-0 bottom-0 w-full h-1/4 bg-gradient-to-t from-black to-transparent"></span>
      <div className="absolute z-10 inset-0">
        <div className="mx-auto max-w-7xl flex flex-col justify-center h-full gap-y-6 items-center text-center">
          <h1 className="text-6xl font-semibold text-white">
            {blok.title ? blok.title : entry.name}
          </h1>
          <p className="text-white leading-loose max-w-[60ch]">
            {blok.content}
          </p>
        </div>
      </div>
    </div>
  );
}
